var _path, _path2, _path3, _path4, _circle, _path5, _polygon, _path6, _path7, _path8, _circle2, _rect, _rect2, _ellipse, _ellipse2, _circle3, _circle4, _path9, _ellipse3, _ellipse4, _path10, _ellipse5, _circle5, _rect3, _rect4, _ellipse6, _ellipse7, _path11, _ellipse8, _circle6, _rect5, _rect6, _ellipse9, _ellipse10, _circle7, _circle8, _path12, _ellipse11, _circle9, _rect7, _rect8, _ellipse12, _ellipse13, _circle10, _circle11, _path13, _ellipse14, _path14, _path15, _path16, _ellipse15, _circle12, _polygon2, _polygon3, _ellipse16, _circle13, _circle14, _ellipse17, _path17, _path18, _ellipse18;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgError(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "Layer 1",
    width: 878.64034,
    height: 552.21468,
    viewBox: "0 0 878.64034 552.21468",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M998.54278,726.10734H255.9092a24.9009,24.9009,0,0,1-24.9009-24.9009v0q403.8068-46.93008,792.43539,0v0A24.90091,24.90091,0,0,1,998.54278,726.10734Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#ccc"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1023.44369,702.67117,231.0083,701.20641l91.84049-154.53222.43941-.73238V205.37035a31.47506,31.47506,0,0,1,31.47769-31.47769H895.29181a31.47506,31.47506,0,0,1,31.47769,31.47769v342.915Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#e6e6e6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M354.04817,195.86407a10.26484,10.26484,0,0,0-10.25332,10.25332V516.6466a10.2653,10.2653,0,0,0,10.25332,10.25332H900.40381a10.26575,10.26575,0,0,0,10.25332-10.25332V206.11739a10.26529,10.26529,0,0,0-10.25332-10.25332Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M357.63886,567.91321a4.40643,4.40643,0,0,0-3.99233,2.55761l-28.29891,61.51994a4.39408,4.39408,0,0,0,3.99161,6.231H924.45037a4.39378,4.39378,0,0,0,3.92939-6.35969l-30.76-61.51994a4.372,4.372,0,0,0-3.92939-2.42887Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 464.34902,
    cy: 10.25332,
    r: 6.59142,
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M566.53427,649.9398a4.401,4.401,0,0,0-4.24265,3.25137l-7.09851,26.36568a4.39386,4.39386,0,0,0,4.24265,5.5372H694.43332a4.39329,4.39329,0,0,0,4.15111-5.83187l-9.12615-26.36568a4.39658,4.39658,0,0,0-4.15254-2.9567Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#ccc"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "766.09 366.922 766.09 372.782 162.169 372.782 162.623 372.049 162.623 366.922 766.09 366.922",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M852.22715,554.23663a1.07171,1.07171,0,0,0-1.03315.79175l-1.7286,6.42045a1.07,1.07,0,0,0,1.03316,1.34839H883.3725a1.06983,1.06983,0,0,0,1.01085-1.42015l-2.22235-6.42044a1.07064,1.07064,0,0,0-1.01121-.72Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M804.22715,554.23663a1.07171,1.07171,0,0,0-1.03315.79175l-1.7286,6.42045a1.07,1.07,0,0,0,1.03316,1.34839H835.3725a1.06983,1.06983,0,0,0,1.01085-1.42015l-2.22235-6.42044a1.07064,1.07064,0,0,0-1.01121-.72Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#ccc"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M665.1612,595.03225h2.57647l-5.153-344.38824h-2.57648l.10279,6.8706H602.36432l.10278-6.8706h-2.57647l-5.153,344.38824h2.57648l.33411-22.3294h67.17883Zm-3.71375-248.2H601.0279l.62963-42.08234h59.16028Zm.03858,2.57648.62963,42.08233h-61.756l.62964-42.08233Zm.66821,44.65881.62964,42.08234H599.69147l.62964-42.08234Zm.66821,44.65881.62964,42.08234H599.02326l.62964-42.08234Zm.66821,44.65882.62964,42.08239H598.355l.62964-42.08239ZM660.1496,260.09109l.62964,42.08234H601.69611l.62964-42.08234ZM597.68683,570.12637l.62964-42.08234h65.84241l.62964,42.08234Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 457.7944,
    cy: 153.35761,
    r: 42.01233,
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 632.56176,
    y: 357.23822,
    width: 12.76324,
    height: 22.86749,
    transform: "translate(-216.13362 -54.17899) rotate(-10.26106)",
    fill: "#2f2e41"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 607.4436,
    y: 361.78527,
    width: 12.76324,
    height: 22.86749,
    transform: "translate(-217.34533 -58.58065) rotate(-10.26106)",
    fill: "#2f2e41"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 613.67177,
    cy: 387.29848,
    rx: 10.63602,
    ry: 3.98853,
    transform: "translate(-265.60562 314.45381) rotate(-40.26106)",
    fill: "#2f2e41"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 638.2667,
    cy: 382.84606,
    rx: 10.63605,
    ry: 3.98853,
    transform: "translate(-256.9018 329.29406) rotate(-40.26106)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 454.85318,
    cy: 143.08115,
    r: 14.35864,
    fill: "#fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 448.95181,
    cy: 137.93436,
    r: 4.78622,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M651.61608,281.54535c.63177-15.55359-12.77313-28.7276-29.9408-29.42493s-31.59692,11.346-32.22873,26.8996,11.30191,19.08746,28.46955,19.78485S650.9843,297.09893,651.61608,281.54535Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#709dfd"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 579.68164,
    cy: 319.59634,
    rx: 6.59448,
    ry: 21.00616,
    transform: "translate(-22.02934 639.32717) rotate(-77.0899)",
    fill: "#2f2e41"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 662.15028,
    cy: 333.31081,
    rx: 6.59448,
    ry: 21.00616,
    transform: "translate(28.6462 730.3615) rotate(-77.0899)",
    fill: "#2f2e41"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M630.01293,343.80682a9.57243,9.57243,0,1,1-18.8353,3.42883l-.00335-.01849c-.94175-5.20215,3.08038-7.043,8.28256-7.98474S629.07122,338.60467,630.01293,343.80682Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#fff"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 469.86576,
    cy: 467.52635,
    rx: 21.53369,
    ry: 6.76007,
    transform: "translate(-295.28292 565.61186) rotate(-69.08217)",
    fill: "#2f2e41"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 430.05859,
    cy: 500.04835,
    r: 43.06735,
    transform: "translate(-293.10046 670.56224) rotate(-80.78252)",
    fill: "#2f2e41"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 249.75315,
    y: 359.95537,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275.92063,
    y: 359.95537,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 260.65629,
    cy: 383.66967,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 286.82377,
    cy: 383.12453,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M388.28186,459.997c-3.47748-15.57379,7.63867-31.31046,24.82861-35.14884s33.94422,5.67508,37.42169,21.24888-7.91491,21.31765-25.10485,25.156S391.75934,475.57078,388.28186,459.997Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#709dfd"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 381.55043,
    cy: 480.06495,
    rx: 6.76007,
    ry: 21.53368,
    transform: "translate(-376.387 445.19187) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 82.9008,
    cy: 369.76318,
    r: 43.06733,
    fill: "#2f2e41"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 63.27519,
    y: 403.56287,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 89.44267,
    y: 403.56287,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 74.17827,
    cy: 427.27716,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.34581,
    cy: 426.732,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.99113,
    cy: 358.86008,
    r: 14.71922,
    fill: "#fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 83.99113,
    cy: 358.86008,
    r: 4.90642,
    fill: "#3f3d56"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M201.80384,503.60449c-3.47748-15.57379,7.63867-31.31043,24.82861-35.14881s33.94421,5.67511,37.42169,21.2489-7.91492,21.31769-25.10486,25.156S205.28137,519.17834,201.80384,503.60449Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#709dfd"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 268.66855,
    cy: 387.38342,
    rx: 21.53369,
    ry: 6.76007,
    transform: "translate(-349.78596 326.14528) rotate(-69.08217)",
    fill: "#2f2e41"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 228.86138,
    cy: 419.90542,
    r: 43.06735,
    transform: "translate(-382.96135 404.65755) rotate(-80.78252)",
    fill: "#2f2e41"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 48.55595,
    y: 279.81244,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 74.72343,
    y: 279.81244,
    width: 13.08374,
    height: 23.44171,
    fill: "#2f2e41"
  })), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 59.45909,
    cy: 303.52674,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 85.62657,
    cy: 302.9816,
    rx: 10.90314,
    ry: 4.08868,
    fill: "#2f2e41"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.27189,
    cy: 235.10965,
    r: 14.71922,
    fill: "#fff"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 69.27189,
    cy: 235.10965,
    r: 4.90642,
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M187.08466,379.854c-3.47748-15.57379,7.63867-31.31046,24.82861-35.14884s33.94422,5.67508,37.42169,21.24888-7.91491,21.31765-25.10485,25.156S190.56214,395.42785,187.08466,379.854Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#709dfd"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 180.35323,
    cy: 399.92202,
    rx: 6.76007,
    ry: 21.53368,
    transform: "translate(-418.95394 217.60525) rotate(-64.62574)",
    fill: "#2f2e41"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M271.20359,255.46135a3.00328,3.00328,0,0,0-3,3v150a3.00328,3.00328,0,0,0,3,3h287a3.00328,3.00328,0,0,0,3-3v-150a3.00328,3.00328,0,0,0-3-3Z",
    transform: "translate(-160.67983 -193.89266)",
    fill: "#709dfd"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M588.7,348.49c-8.73-11.6-21.38-18.92-35.46-18.92s-26.73,7.32-35.46,18.92a38.39,38.39,0,0,0,8.4,12.65,38.28,38.28,0,0,0,62.52-12.65Z",
    transform: "translate(-295.65 -247.09)",
    fill: "#fff"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M513.17,355.28a9.17,9.17,0,0,1-1.76-1,7.06,7.06,0,0,1-1.94-2.51,7.18,7.18,0,1,0-11.72,1.74,8,8,0,0,0,1.7,1.37,4.94,4.94,0,0,1,1.91,2,14.44,14.44,0,0,0,3.32,4.36,29,29,0,0,0,4.55,3.2A66.31,66.31,0,0,0,505.49,384a27.05,27.05,0,0,0-7.62,1.23,12.29,12.29,0,0,0-3.53,1.76,8.48,8.48,0,0,0-.87-.06,7.19,7.19,0,1,0,6.73,9.72,4.59,4.59,0,0,1,3.71-3,16.75,16.75,0,0,1,1.85-.12,64.4,64.4,0,0,0,8.55,26.67c-4.24,3.29-6.85,6.88-7.95,10.86a3,3,0,0,0-.57.41,6.81,6.81,0,0,0-.84.78A7.18,7.18,0,1,0,517,434.6a4.71,4.71,0,0,1,1.17-5.08c.48-.45,1-.93,1.7-1.46,8.11,9.47,17.76,15.54,29.81,16.26V380.07C533.75,379.2,519.87,368.83,513.17,355.28ZM613,387a7.93,7.93,0,0,0-.87.06,13.56,13.56,0,0,0-3.53-1.76,26.86,26.86,0,0,0-7.62-1.23,67.76,67.76,0,0,0-3.74-19.55,29,29,0,0,0,4.55-3.2,15.58,15.58,0,0,0,3.44-4.57A4.22,4.22,0,0,1,607,355a0,0,0,0,0,0,0,7.18,7.18,0,1,0-10-3.17,6.82,6.82,0,0,1-1.94,2.51,18.85,18.85,0,0,1-1.76,1.29c-6.7,13.54-20.57,23.62-36.48,24.49v64.31c12-.72,21.71-6.82,29.81-16.26.63.5,1.16.95,1.61,1.37a4.86,4.86,0,0,1,1.26,5.23,7.18,7.18,0,1,0,12.08-2.33,6.81,6.81,0,0,0-.84-.78c-.33-.26-.57-.41-.57-.41-1.1-4-3.7-7.57-8-10.86a64.4,64.4,0,0,0,8.55-26.67,15.9,15.9,0,0,1,1.77.12,4.8,4.8,0,0,1,3.85,3,7.18,7.18,0,0,0,13.85-2.18A7.29,7.29,0,0,0,613,387Z",
    transform: "translate(-295.65 -247.09)",
    fill: "#fff"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 853.28249,
    cy: 546.50272,
    rx: 6.76007,
    ry: 21.53369,
    transform: "translate(-299.56006 166.77183) rotate(-20.91783)",
    fill: "#2f2e41"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 884.08966,
    cy: 588.02473,
    r: 43.06733,
    transform: "translate(-243.45509 -24.68433) rotate(-9.21747)",
    fill: "#2f2e41"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "743.035 447.932 729.952 447.932 732.512 476.005 743.058 473.14 743.035 447.932",
    fill: "#2f2e41"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "714.512 448.005 701.428 448.005 703.988 476.078 714.058 473.14 714.512 448.005",
    fill: "#2f2e41"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 863.99793,
    cy: 647.21172,
    rx: 10.90314,
    ry: 4.08868,
    transform: "translate(-205.5736 -109.16812) rotate(-4.18164)",
    fill: "#2f2e41"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.31949,
    cy: 403.22896,
    r: 14.71922,
    fill: "#fff"
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 722.31949,
    cy: 403.22896,
    r: 4.90642,
    fill: "#3f3d56"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 929.59781,
    cy: 558.04133,
    rx: 21.53368,
    ry: 6.76007,
    transform: "translate(-232.25121 800.3487) rotate(-53.5499)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M863.07681,610.23132c0-3.474,8.945-10.334,18.8708-10.334s19.23228,9.7805,19.23228,13.25448-9.30655-.674-19.23228-.674S863.07681,613.70534,863.07681,610.23132Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#fff"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M925.86638,547.97334c3.47748-15.57379-7.63867-31.31046-24.82861-35.14884s-33.94421,5.67508-37.42169,21.24887,7.91492,21.31766,25.10486,25.156S922.38891,563.54716,925.86638,547.97334Z",
    transform: "translate(-160.67983 -173.89266)",
    fill: "#709dfd"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 892.69043,
    cy: 647.14249,
    rx: 10.90314,
    ry: 4.08868,
    transform: "translate(-205.49217 -107.07609) rotate(-4.18164)",
    fill: "#2f2e41"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.f68ae06047b82c610bb9164e7cff0c95.svg";
export { ForwardRef as ReactComponent };